import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Checkbox, ErrorMessage, Radio } from "@components/atoms";
import { Money } from "@components/containers";
import { Formik } from "formik";
import React from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { commonMessages } from "../../../../intl";
import * as S from "./styles";

/**
 * Shipping method selector used in checkout.
 */
var CheckoutShipping = function CheckoutShipping(_ref) {
  var shippingMethods = _ref.shippingMethods,
      selectedShippingMethodId = _ref.selectedShippingMethodId,
      acceptTerms = _ref.acceptTerms,
      selectShippingMethod = _ref.selectShippingMethod,
      shippingErrors = _ref.errors,
      formId = _ref.formId,
      formRef = _ref.formRef;
  var intl = useIntl();
  return React.createElement("section", null, React.createElement(S.Title, {
    "data-cy": "checkoutPageSubtitle"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Shipping method",
    "id": "@next.components.organisms.CheckoutShipping.CheckoutShipping.2281316216"
  }, "id", "@next.components.organisms.CheckoutShipping.CheckoutShipping.2281316216"))), React.createElement(Formik, {
    initialValues: {
      accepted: acceptTerms,
      shippingMethod: selectedShippingMethodId
    },
    enableReinitialize: true,
    onSubmit: function onSubmit(values, _ref2) {
      var setSubmitting = _ref2.setSubmitting;

      if (selectShippingMethod && values.shippingMethod && values.accepted) {
        selectShippingMethod(values.shippingMethod);
      }

      setSubmitting(false);
    },
    validate: function validate(values) {
      var errors = {};

      if (!values.accepted) {
        errors.accepted = "Required field";
      }

      return errors;
    }
  }, function (_ref3) {
    var handleSubmit = _ref3.handleSubmit,
        values = _ref3.values,
        setFieldValue = _ref3.setFieldValue,
        errors = _ref3.errors;
    return React.createElement(S.ShippingMethodForm, {
      id: formId,
      ref: formRef,
      onSubmit: handleSubmit
    }, shippingMethods.map(function (_ref4, index) {
      var id = _ref4.id,
          name = _ref4.name,
          price = _ref4.price,
          translation = _ref4.translation;
      var checked = !!values.shippingMethod && values.shippingMethod === id;
      return React.createElement(S.Tile, {
        checked: checked,
        key: id
      }, React.createElement(Radio, {
        "data-cy": "checkoutShippingMethodOption".concat(index, "Input"),
        name: "shippingMethod",
        value: id,
        checked: checked,
        customLabel: true,
        onChange: function onChange() {
          return setFieldValue("shippingMethod", id);
        }
      }, React.createElement("span", {
        "data-cy": "checkoutShippingMethodOption".concat(index, "Name")
      }, (translation === null || translation === void 0 ? void 0 : translation.name) || name), React.createElement(S.Price, null, React.createElement(Money, {
        "data-cy": "checkoutShippingMethodOption".concat(index, "Price"),
        money: price
      }))));
    }), React.createElement(ErrorMessage, {
      errors: shippingErrors
    }), React.createElement(S.Text, null, intl.formatMessage(_defineProperty({
      defaultMessage: "Standart delivery is our best delivery method thant includes tracking of door status from the order is sheduled up to shipment is done. Estimated ship term is by 10 July.",
      "id": "@next.components.organisms.CheckoutShipping.CheckoutShipping.3550040846"
    }, "id", "@next.components.organisms.CheckoutShipping.CheckoutShipping.3550040846"))), React.createElement(S.CheckboxWr, null, React.createElement(Checkbox, {
      className: "accepted-checkbox",
      name: "accepted",
      color: "primary",
      checked: values.accepted,
      onChange: function onChange() {
        return setFieldValue("accepted", !values.accepted);
      }
    }, intl.formatMessage(commonMessages.accept)), React.createElement(Link, {
      to: "#"
    }, intl.formatMessage(commonMessages.termsOfService)), React.createElement(S.ErrorMsg, null, errors.accepted)));
  }));
};

export { CheckoutShipping };